document.addEventListener('DOMContentLoaded', function() {

// Home
var home = document.querySelector('.home');
if(home){

    var IE = detectIE();

    // Page load animation
    var home_hero = document.querySelector('#home_hero');
    var home_hero_content = document.querySelector('.hero-content-wrap');
    var header = document.querySelector('header');
    var main_content = document.querySelector('main');
    var loading = home.querySelector('#loading_screen');

    // If Internet Explorer
    if(IE){

        // Disable Scroll Animations
        home.classList.add('static');

        // Disable Load Animation
        loading.classList.add('d-none');

        // Standard Animations
        if(header){
            header.classList.add('in');
        }
        if(home_hero){
            home_hero.classList.add('in');
        }
        if(home_hero_content){
            setTimeout(function(){
                home_hero_content.classList.add('no-transition');
            }, 2000);
        }
        if(main_content){
            main_content.classList.add('in');
        }

        // Unfix body
        home.classList.add('unfix');


    // Non Internet Explorer
    } else{

        // 
        // Page Load Animations
        // 

        // This prevents the page from scrolling down to where it was previously.
        // if ('scrollRestoration' in history) {
        //     history.scrollRestoration = 'manual';
        // }

        // Animate loading screen
        const loading_1 = loading.querySelector('#loading_1');
        const loading_2 = loading.querySelector('#loading_2');

        setTimeout(function(){
            loading_1.classList.add('in');
        }, 200);
        setTimeout(function(){
            loading_1.classList.add('out');
        }, 1300);
        setTimeout(function(){
            loading_2.classList.add('out');
        }, 2600);

        // Animate page after loading screen
        setTimeout(function(){
            loading.classList.add('d-none');
            if(header){
                header.classList.add('in');
            }
            if(home_hero){
                home_hero.classList.add('in');
            }
            if(main_content){
                main_content.classList.add('in');
            }
            home.classList.add('unfix');

            // Resize trigger (Slider requires a resize to fit properly, temp fix)
            window.dispatchEvent(new Event('resize'));

        }, 3600);


        // setTimeout(function(){


            // 
            // SCROLL ANIMATIONS
            // 

            let scenes = [];
            
            // Sections
            const home_slanted = document.querySelector('#home_slanted');
            const home_services = document.querySelector('#home_services');
            const home_grid = document.querySelector('#home_grid');
            const home_quote = document.querySelector('#home_quote');
            const home_slider = document.querySelector('.home #full_width_slider');
            const home_news = document.querySelector('#home_news');

            // Controller
            const controller = new ScrollMagic.Controller();




            // 
            // Section 1 (HOME HERO)
            // 

            if(home_hero){
                // Animation
                const hero_content = document.querySelector('.hero-content-wrap .inside-wrap');

                // Scenes
                let hero_scene_1 = addTween({
                    duration: 500,
                    triggerElement: home_hero,
                    triggerHook: 0
                }, hero_content, {opacity: 1, transform: "translateY(0)"}, {opacity: 0, transform: "translateY(-50px)"});
            }
            



            // 
            // Section 2 (SLANTED SECTION)
            // 

            if(home_slanted){
                // Fix
                let slanted_scene_1 = addPin({
                    duration: 1550,
                    triggerElement: home_slanted,
                    triggerHook: 0
                });

                // Animation 1 & 2
                const intro_text = document.querySelector('#home_slanted .intro-text');
                let slanted_scene_2 = addTween({
                    duration: 750,
                    triggerElement: home_slanted,
                    triggerHook: 0
                }, intro_text, {opacity: 0, transform: "translateY(200px)"});

                let slanted_scene_3 = addTween({
                    duration: 700,
                    triggerElement: home_slanted,
                    offset: 1700
                }, intro_text, false, {opacity: 0, transform: "translateY(-100px)"});

                // Animation 3
                const slanted_image = document.querySelector('#home_slanted .slanted-image');
                let slanted_scene_4 = addTween({
                    duration: 1100,
                    triggerElement: home_slanted,
                    triggerHook: 0
                }, slanted_image, {right: "-80vw"}, {right: "-40vw"});
            }



            // 
            // Section 3 (SERVICES SECTION)
            // 

            if(home_services){
                // Fix
                let services_scene_1 = addPin({
                    duration: 1800,
                    triggerElement: home_services,
                    triggerHook: 0
                });

                // Animation 1
                const services_text = document.querySelector('#home_services .services-title-block');
                let services_scene_2 = addTween({
                    duration: 750,
                    triggerElement: home_services,
                    triggerHook: 0
                }, services_text, {opacity: 0, transform: "translateY(20px)"});
                let services_scene_3 = addTween({
                    duration: 1000,
                    triggerElement: home_services,
                    offset: 1800
                }, services_text, false, {opacity: 0, transform: "translateY(-30vh)"});

                // Animation 2
                const services_items = document.querySelectorAll('#home_services .services-item');
                for(const [i, item] of services_items.entries()){
                    const duration = 1000;
                    const offset = 200 * i;
                    let in_tween = addTween({
                        duration: duration,
                        triggerElement: home_services,
                        offset: offset
                    }, item, {opacity: 0, transform: "translateY(80vh)"});
                    let out_tween = addTween({
                        duration: duration,
                        triggerElement: home_services,
                        offset: (offset + 1900)
                    }, item, false, {opacity: 0, transform: "translateY(-30vh)"});
                }
            }









            // 
            // Section 5 (QUOTE SECTION)
            // 

            if(home_quote){
                // Fix
                let quote_scene_1 = addPin({
                    duration: 2000,
                    triggerElement: home_quote,
                    triggerHook: 0
                });

                // Animation 1 & 2
                const quote_separators = document.querySelectorAll('#home_quote .diamond-separator');
                const quote_options = {
                    0: {
                        'in': {ease: Back. easeOut.config( 1.4), opacity: 0, transform: "translateX(50%)"},
                        'out': {ease: Back. easeIn.config( 1.4), opacity: 0, transform: "translateX(-50%)"}
                    },
                    1: {
                        'in': {ease: Back. easeOut.config( 1.4), opacity: 0, transform: "translateX(-50%)"},
                        'out': {ease: Back. easeIn.config( 1.4), opacity: 0, transform: "translateX(50%)"}
                    }
                }

                for(const [i, separator] of quote_separators.entries()){
                    const duration = 900;
                    let in_tween = addTween({
                        duration: duration,
                        triggerElement: home_quote,
                        triggerHook: 0
                    }, separator, quote_options[i]['in']);
                    let out_tween = addTween({
                        duration: duration,
                        triggerElement: home_quote,
                        offset: 2000
                    }, separator, false, quote_options[i]['out']);
                }

                // Animation 3
                const quote = document.querySelector('#home_quote .quote');
                let quote_scene_2 = addTween({
                    duration: 750,
                    triggerElement: home_quote,
                    offset: 900
                }, quote, {opacity: 0, transform: "translateY(20px)"});
                let quote_scene_3 = addTween({
                    duration: 750,
                    triggerElement: home_quote,
                    offset: 2000
                }, quote, false, {opacity: 0, transform: "translateY(-20px)"});
            }



            // 
            // Section 6 (SLIDER SECTION)
            // 

            if(home_slider){
                // Fix
                let slider_scene_1 = addPin({
                    duration: 1800,
                    triggerElement: home_slider,
                    triggerHook: 0
                });

                // Animation 1
                const page_containers = document.querySelectorAll('.home #full_width_slider .page-container');
                for(const [i, p] of page_containers.entries()){
                    const duration = 1000;
                    let in_tween = addTween({
                        duration: duration,
                        triggerElement: home_slider,
                        triggerHook: 0
                    }, p, {opacity: 0, transform: 'translateX(-50vw)'});
                }

                // Animation 2
                const slider_title = document.querySelector('.home #full_width_slider>h4');
                let slider_scene_2 = addTween({
                    duration: 750,
                    triggerElement: home_slider,
                    triggerHook: 0
                }, slider_title, {opacity: 0, transform: "translateY(20px)"});
                let sliderscene_3 = addTween({
                    duration: 750,
                    triggerElement: home_slider,
                    offset: 1800
                }, slider_title, false, {opacity: 0, transform: "translateY(-20px)"});
            }






            // 
            // Mobile Layout
            // 

            if(window.innerWidth < 768 || window.innerHeight < 710){
                home.classList.add('static');
                destroyAndReset();
            }
            window.addEventListener('resize', function(){
                if(window.innerWidth < 768 || window.innerHeight < 710){
                    home.classList.add('static');
                    destroyAndReset();
                }
            });


            //
            // Functions
            //

            function addPin(options){
                let new_scene = new ScrollMagic.Scene(options);
                new_scene.setPin(options['triggerElement']);
                new_scene.addTo(controller);
                scenes.push({
                    type: 'pin',
                    target: options['triggerElement'],
                    scene: new_scene
                });
                return new_scene;
            }

            function addTween(options, target, from, to){
                let new_scene = new ScrollMagic.Scene(options);
                if(!to){
                    new_scene.setTween(
                        TweenMax.from(target, (options['duration'] / 1000), from)
                    );
                } else if(!from){
                    new_scene.setTween(
                        TweenMax.to(target, (options['duration'] / 1000), to)
                    );
                } else{
                    new_scene.setTween(
                        TweenMax.fromTo(target, (options['duration'] / 1000), from, to)
                    );
                }
                new_scene.addTo(controller);
                scenes.push({
                    type: 'tween',
                    target: target,
                    scene: new_scene
                });
                return new_scene;
            }

            function destroyAndReset(){
                if(scenes.length){
                    scenes.forEach(function(scene){
                        if(scene['type'] == 'pin'){
                            scene['scene'].destroy(true);
                        } else{
                            scene['scene'].destroy(true);
                            scene['target'].style = "";
                        }
                    });
                }
                controller.destroy(true);
            }



            // }, 5600);


            

    }


    // 
    // GLOBAL FEATURES
    // 
    
        var hero_video = document.querySelector('.slider-video');
        if(hero_video){
            // init Player
            var player = new Vimeo.Player(hero_video);

            // Controls
            var controls = document.querySelector('.controls');
            if(controls){
                // Sound toggle
                var video_sound = controls.querySelector('.sound');
                var video_sound_span = controls.querySelector('.sound span');
                video_sound.addEventListener('click', function(){
                    if(video_sound.classList.contains('with-sound')){
                        video_sound.classList.remove('with-sound');
                        player.setVolume(1);
                        video_sound_span.innerHTML = 'Play without Sound';
                    } else{
                        video_sound.classList.add('with-sound');
                        player.setVolume(0);
                        video_sound_span.innerHTML = 'Play with Sound';
                    }
                });

                // Play/Pause
                var video_pause = controls.querySelector('.pause');
                var video_pause_span = controls.querySelector('.pause span');
                video_pause.addEventListener('click', function(){
                    if(video_pause.classList.contains('paused')){
                        video_pause.classList.remove('paused');
                        player.play();
                        video_pause_span.innerHTML = 'Pause Video';
                    } else{
                        video_pause.classList.add('paused');
                        player.pause();
                        video_pause_span.innerHTML = 'Play Video';
                    }
                });
            }

            // Pause video on small screen sizes
            if(window.innerWidth < 768 || window.innerHeight < 710){
                player.pause();
            }

            // Pause and play on resize depending on current settings
            window.addEventListener('resize', function(){
                if(window.innerWidth < 768 || window.innerHeight < 710){
                    player.pause();
                } else{
                    if(!video_pause.classList.contains('paused')){
                        player.play();
                    }
                }
            });
        }
    
    
    //
    // Functions
    //

    // Nav Scroll
    window.onscroll = function() {scrollNav()};
    function scrollNav(){
        if(document.documentElement.scrollTop > 40){
            document.body.classList.add('scrolled');
        } else{
            document.body.classList.remove('scrolled');
        }
    }
    
    // Detect browser
    function detectIE() {
        var ua = window.navigator.userAgent;
    
        var msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }
    
        var trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }
    
        // other browser
        return false;
    }


}

});